import SurveyTab from "./SurveyTab"

export default SurveyTab